export const INCOMING_SOUND_INTERVAL = 15; // seconds

export const ORDERS_REFRESH_INTERVAL = 60; // seconds
